module.exports = __webpack_public_path__ + "img/Listing-Report-Thank-You-en.afa344a.png";